export default __webpack_public_path__ + "static/media/servicetagnew.405bdaa9.svg";